import './upgradeApi.less';

import { Button } from '@bfe/moly';
import { useEffect, useState } from 'react';

import { ReactComponent as IconUpgrade } from '@/assets/icon/api-management/icon-upgrade.svg';
import { useErrorMsg } from '@/hooks/useErrorMsg';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useI18nContext } from '@/i18n/I18n';
import { getUserTag } from '@/services/user';

import ConfirmModal, { UPGRADE_STATUS } from './components/ConfirmModal';
import FailModal from './components/FailModal';
import ProcessModal from './components/ProcessModal';

const UpgradeApi = () => {
  const [$t] = useI18nContext();
  const [visible, setVisible] = useState(false);
  const [processVisible, setProcessVisible] = useState(false);
  const [failVisible, setFailVisible] = useState(false);
  const [failCodes, setFailCodes] = useState<string[]>([]);
  const [upgradeStatus, setUpgradeStatus] = useState(UPGRADE_STATUS.SUCCESS);

  const { mutate } = useUserProfile();
  const { msgError } = useErrorMsg(mutate);

  const handleUpgradeButton = () => {
    setVisible(true);
  };

  const handleConfirmUpgrade = (
    status: UPGRADE_STATUS,
    failCodes?: string[],
  ) => {
    setVisible(false);
    setUpgradeStatus(status);
    if (status === UPGRADE_STATUS.FAIL) {
      setFailCodes(failCodes || []);
      setFailVisible(true);
    } else if (status === UPGRADE_STATUS.PROCESS) {
      setProcessVisible(true);
    }
  };

  useEffect(() => {
    getUserTag(['UTA_PRO', 'UTA'])
      .then((res) => {
        let status = res?.result?.user_tags?.UTA_PRO;
        if (!status) {
          status =
            res?.result?.user_tags?.UTA === UPGRADE_STATUS.PROCESS
              ? UPGRADE_STATUS.PROCESS
              : '';
        }
        setUpgradeStatus(status);
      })
      .catch((error) => {
        msgError(error);
      });
  }, []);

  if (upgradeStatus === UPGRADE_STATUS.SUCCESS) {
    return null;
  }

  return (
    <>
      <div className="upgrade-api__notice">
        <i className="upgrade-api__notice--icon-upgrade">
          <IconUpgrade />
        </i>
        <div className="upgrade-api__notice--text">
          <span>
            {upgradeStatus === UPGRADE_STATUS.PROCESS
              ? $t('UpgradeToApiProIng')
              : $t('UpgradeToApiPro')}
          </span>
          <span>
            {upgradeStatus === UPGRADE_STATUS.PROCESS ? (
              <i>{$t('UpgradeToApiProIngDesc')}</i>
            ) : (
              <>
                <i>{$t('UpgradeToApiProText1')}</i>
                <i>{$t('UpgradeToApiProText2')}</i>
                <i>{$t('UpgradeToApiProText3')}</i>
              </>
            )}
          </span>
        </div>
        {upgradeStatus === UPGRADE_STATUS.PROCESS ? null : (
          <Button
            onClick={handleUpgradeButton}
            variant="primary"
            size="x-small"
            className="upgrade-api__notice--button bybit-btn-primary"
          >
            {$t('UpgradeToApiUpgradeButton')}
          </Button>
        )}
      </div>
      <ConfirmModal
        visible={visible}
        onCancel={() => setVisible(false)}
        onConfirm={handleConfirmUpgrade}
      />
      <ProcessModal
        visible={processVisible}
        onConfirm={() => setProcessVisible(false)}
      />
      <FailModal
        visible={failVisible}
        failCodes={failCodes}
        onConfirm={() => setFailVisible(false)}
      />
    </>
  );
};

export default UpgradeApi;
